<template>
    <!-- No top border: the covered-assets section above already renders a divider. -->
    <div class="mt-4">
        <small class="mb-3 block text-muted">{{ trans('quality_assurance.configuration.modal.term.caption') }}</small>
        <div class="row">
            <div class="col-6">
                <!-- SLA carries the start → read-only; otherwise the user sets it (not in the past). -->
                <jet-date-picker
                    v-if="slaStart"
                    :horizontal="false"
                    :label="trans('quality_assurance.configuration.modal.term.start')"
                    :model-value="slaStart"
                    :readonly="true"
                />
                <jet-date-picker
                    v-else
                    :horizontal="false"
                    :invalid-feedback="startError"
                    :label="trans('quality_assurance.configuration.modal.term.start')"
                    :min-date="today"
                    :model-value="start"
                    :required="true"
                    @update:model-value="(value) => emit('update:start', value)"
                />
            </div>
            <div class="col-6">
                <jet-date-picker
                    v-if="slaEnd"
                    :horizontal="false"
                    :label="trans('quality_assurance.configuration.modal.term.end')"
                    :model-value="slaEnd"
                    :readonly="true"
                />
                <template v-else>
                    <!-- Open-ended: clearing the date leaves the term without an end. -->
                    <jet-date-picker
                        :horizontal="false"
                        :invalid-feedback="endError"
                        :label="trans('quality_assurance.configuration.modal.term.end')"
                        :min-date="slaStart || start"
                        :model-value="end"
                        @update:model-value="(value) => emit('update:end', value)"
                    />
                    <small class="text-muted">{{ trans('quality_assurance.configuration.modal.term.end_hint') }}</small>
                </template>
            </div>
        </div>
    </div>
</template>

<script setup>
import JetDatePicker from '@/Jetstream/Datepicker.vue';
import { trans } from '@/mixins/i18n';
import { DateTime } from 'luxon';
import { computed } from 'vue';

defineProps({
    slaStart: { type: String, default: null },
    slaEnd: { type: String, default: null },
    start: { type: String, default: null },
    end: { type: String, default: null },
    startError: { type: String, default: '' },
    endError: { type: String, default: '' },
});

const emit = defineEmits(['update:start', 'update:end']);

const today = computed(() => DateTime.now().toISODate());
</script>
